<template>
<Modal label="Data Ujian TAPI">

    <template v-if="user.role == 'mahasiswa'">
        <InputCustom
          v-model="item.link" 
          :error="error.link"
          :errorMsg="errorMsg.link"
          @onFocus="resetError('link')"
          placeholder="Link Berkas"
          label="Link Berkas"
        >
        </InputCustom>
        <p>Silahkan update link berkas apabila terdapat perubahan link.</p>
    </template>

    <template v-else>

      <div class="r-lecture-list y-lightgray-bg">
        <p ><strong>{{item.student}}</strong></p>
        <p>Mahasiswa</p>
      </div>
      <div class="r-lecture-list" v-for="(d,i) in item.lectures" :key="`lecture-detail-${i}`">
        <p ><strong>{{d.lecture}}</strong></p>
        <p>{{d.type}} {{d.order}}</p>
      </div>

      <div class="y-inputField">
        <div class="y-labelText">
            Tanggal Pelaksanaan Ujian
        </div>
        <div class="y-hasIcon-right y-lr-size" style="position: relative">
            <date-picker v-model="item.dateTemp" format="DD-MM-YYYY" :disabled-date="notBeforeToday"></date-picker>
        </div>
        <div class="y-errorText y-red-text" :style="error.dateTemp ? 'opacity: 1 !important;': ''">
            {{errorMsg.dateTemp}}
        </div>
      </div>
      <div class="y-inputField" >
          <div class="y-labelText">
              Sesi
          </div>
          <div class="y-inputPlace y-hasIcon-right">
              <div class="y-select-hasIcon" style="width: 100%">
                  <select class="y-select" v-model="item.study_session_id">
                      <option class="y-option" :value="session.id" v-for="session in sessions" :key="`session-${session.id}`">{{session.name}} ({{`${timeFormat(session.beginTime)} - ${timeFormat(session.endTime)}`}})</option>
                  </select>
                  <div class="y-select-icon">
                      <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                  </div>
              </div>
          </div>
          <div class="y-errorText y-red-text" :style="error.study_session_id ? 'opacity: 1 !important;': ''">
              {{errorMsg.study_session_id}}
          </div>
      </div>
      <div class="y-inputField">
          <div class="y-labelText">
              Ruangan
          </div>
          <div class="y-inputPlace y-hasIcon-right">
              <div class="y-select-hasIcon" style="width: 100%">
                  <select class="y-select" v-model="item.room_id">
                      <option class="y-option" :value="room.id" v-for="room in rooms" :key="`room-${room.id}`">{{room.name}}</option>
                  </select>
                  <div class="y-select-icon">
                      <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                  </div>
              </div>
          </div>
          <div class="y-errorText y-red-text" :style="error.room_id ? 'opacity: 1 !important;': ''">
              {{errorMsg.room_id}}
          </div>
      </div>

      <div class="y-inputField">
          <div class="y-labelText">
            Dosen Penguji 1
          </div>
          <div class="y-inputPlace y-hasIcon-right">
              <div class="y-select-hasIcon" style="width: 100%">
                  <select class="y-select" v-model="item.lecture_id">
                      <option class="y-option"
                        v-for="(l,i) in list.filter(x => x.id != item.lecture2_id)" 
                        :key="`list-data-${i}`"
                        :value="l.id"
                        >{{l.name}}</option>
                  </select>
                  <div class="y-select-icon" >
                      <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                  </div>
              </div>
          </div>
      </div>
      <div class="y-inputField">
          <div class="y-labelText">
            Dosen Penguji 2
          </div>
          <div class="y-inputPlace y-hasIcon-right">
              <div class="y-select-hasIcon" style="width: 100%">
                  <select class="y-select" v-model="item.lecture2_id">
                      <option class="y-option"
                        v-for="(l,i) in list.filter(x => x.id != item.lecture_id)" 
                        :key="`list-data-${i}`"
                        :value="l.id"
                        >{{l.name}}</option>
                  </select>
                  <div class="y-select-icon" >
                      <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                  </div>
              </div>
          </div>
      </div>
     
    </template>

    <template #actionButton>
      <ButtonCustom
        :disabled="loading" type="secondary" size="sm" class="r-mlr-10"
        @click.prevent="resetData()"
      > Batal </ButtonCustom>
      
      <ButtonCustom
        :loading="loading"
        type="primary" size="sm" class="r-mlr-10"
        @click.prevent="sendData()"
      >{{user.role == 'mahasiswa' ? inputType : 'Verifikasi'}} </ButtonCustom>
    </template>
</Modal>
</template>
<script>
import common from '@/mixins/function/common'
import { mapGetters, mapActions } from 'vuex'
import validation from '@/mixins/function/validation'
import Modal from '@/components/Helper/Modal'
import datePicker from '@/mixins/datepicker'
import { 
    formatDate, timeFormat
} from "@/common/timeformat"
export default {
  mixins: [common, validation, datePicker],
  components: {
    Modal,
  },
  props: {
    inputType: {
      require: true
    },
    tapiId: {
      require: true
    },
  },
  computed: {
    ...mapGetters({
      item: 'tapiExam/getItem',
      list: 'user/getLecture',
      user: 'auth/getUser',
      sessions: 'studySession/getAllStudySessions'
    }),
    rooms(){
      return this.$store.getters[`room/getItems`]('tapi')
    }
  },
  data: () => ({
    loading: false,
    error: {
      link: false,
      lecture_id: false,
      lecture2_id: false,
      date: false,
      dateTemp: false,
      study_session_id: false,
      room_id: false,
    },
    errorMsg: {
      link: 'Tidak boleh kosong',
      lecture_id: 'Tidak boleh kosong',
      lecture2_id: 'Tidak boleh kosong',
      date: 'Tidak boleh kosong',
      dateTemp: 'Tidak boleh kosong',
      study_session_id: 'Tidak boleh kosong',
      room_id: 'Tidak boleh kosong',
    },
  }),
  methods: {
    ...mapActions({
      store: 'tapiExam/store',
      update: 'tapiExam/update',
    }),
    resetData(){
      this.$emit('resetData')
    },
    async validation(){
      let field = [
        'link',
      ]

      if(this.user.role == 'kaprodi'){
        field = [
          'dateTemp',
          'lecture_id', 
          'lecture2_id',
          'study_session_id',
          'room_id',
        ]
      }
      return await this.validate(field,this.item)
    },
    async sendData(){
      const errorcount = await this.validation()
      if(errorcount === 0){

        this.loading = true
        this.item.date = formatDate(this.item.dateTemp)

        if(this.item.status == 3) await this.update(this.item)
        else await this.store(this.item)

        this.loading = false

        const response = this.getResponse('tapiExam')
        this.showSnackbar({
          type: response.status == 1 ? "success" : "error",
          text: response.msg
        })

        if(response.status === 1){
          this.resetData()
          this.$emit('getData')
        }
      }else{
        this.showSnackbar({
          type: "error",
          text: "Mohon periksa kembali"
        })
      }
    },
    timeFormat(value){
      return timeFormat(value);
    }
  }
}
</script>